import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Stack, TextField, Divider, Alert, Snackbar, Link, Card, CardContent, Grid2, CardHeader, FormControl, InputLabel, Select, MenuItem, Checkbox, Typography } from "@mui/material";
import { isStudent, useAuth } from "../../contexts/AuthContext";
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import { SampleData, AddedQuestionSampleData } from "./SampleData";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { StyledTableCell, StyledTableRow } from '../../theme';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from "react-router-dom";
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { InvokeAPI } from "../../apis/API";
import AsyncButton from "../../components/common/AsyncButton";
import { useAsyncAction } from "../../components/common/useAsyncAction";
import { getUserMgmtBase, getAssessmentMgmtBase } from "../../config/apiBase";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import UpdateIcon from "@mui/icons-material/Update";
import { AddCircle, Assessment, Assignment } from "@mui/icons-material";
import ClassIcon from '@mui/icons-material/Class';
import SchoolIcon from '@mui/icons-material/School';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import PersonIcon from "@mui/icons-material/Person";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";



const AssessmentEdit = () => {
    const { id } = useParams();

    const navigate = useNavigate();
    const { user, logout } = useAuth();
    const detailsRef = useRef(null);
    const participantsRef = useRef(null);
    const questionsRef = useRef(null);
    const publishRef = useRef(null);
    const [tourOpen, setTourOpen] = useState(false);
    const [tourSection, setTourSection] = useState(0);
    const [state, setState] = useState({ open: false, severity: "", message: "" })
    const handleClose = () => {
        setState({ ...state, open: false });
    };

    const [dialog, setDialog] = useState({ open: false, user: false, group: false, question: false, id: "", button: "", content: "" })
    const { run: runDialog, loading: dialogSubmitting } = useAsyncAction();

    const handleDialogClose = () => {
        setDialog({ open: false })
    }

    const handleDialogContinue = async () => {
        await runDialog(async () => {
            if (dialog.user === true) {
                const uinfo = await InvokeAPI(`${getAssessmentMgmtBase()}/v1/assessment/assignment/delete`,
                    {
                        "Aid": id,
                        "UserID": [dialog.id],
                    },
                    'POST',
                    { "authorization": user["token"] },
                    false)
                if (uinfo["unauthenticated"] == true || uinfo["unauthorized"] == true) {
                    logout(user);
                }
                setState({ open: true, severity: "success", message: "Participant removed successfully" })
            } else if (dialog.group === true) {
                const uinfo = await InvokeAPI(`${getAssessmentMgmtBase()}/v1/assessment/assignment/delete`,
                    {
                        "Aid": id,
                        "GroupID": [dialog.id],
                    },
                    'POST',
                    { "authorization": user["token"] },
                    false)
                if (uinfo["unauthenticated"] == true || uinfo["unauthorized"] == true) {
                    logout(user);
                }
                setState({ open: true, severity: "success", message: "Participant removed successfully" })
            } else if (dialog.question === true) {
                const uinfo = await InvokeAPI(`${getAssessmentMgmtBase()}/v1/assessment/question/remove`,
                    {
                        "Aid": id,
                        "Qid": dialog.id,
                    },
                    'POST',
                    { "authorization": user["token"] },
                    false)
                if (uinfo["unauthenticated"] == true || uinfo["unauthorized"] == true) {
                    logout(user);
                }
                setState({ open: true, severity: "success", message: "Question removed successfully" })
            }
            setDialog({ open: false })
        });
    }
    const getTestData = () => {
        let data = {}
        SampleData.forEach(element => {
            if (element.id === id) {
                data = element
                return
            }
        });
        return data
    }

    const testData = getTestData()

    const tourSections = [
        {
            title: "Edit Details",
            description: "Update name, subject, class, and timing for this assignment.",
            targetRef: detailsRef,
        },
        {
            title: "Edit Participants",
            description: "Add or remove students who can attempt this assignment.",
            targetRef: participantsRef,
        },
        {
            title: "Edit Questions",
            description: "Review added questions and add more from the questions editor.",
            targetRef: questionsRef,
        },
        {
            title: "Publish",
            description: "Activate the assignment so assigned students can attempt it.",
            targetRef: publishRef,
        },
    ];

    const startTour = () => {
        setTourSection(0);
        setTourOpen(true);
    };

    const closeTour = () => {
        setTourOpen(false);
    };

    const goToTourSection = (nextSection) => {
        if (nextSection < 0) return;
        if (nextSection >= tourSections.length) {
            closeTour();
            return;
        }
        setTourSection(nextSection);
    };

    useEffect(() => {
        if (!tourOpen) return;
        const target = tourSections[tourSection]?.targetRef?.current;
        if (target) {
            target.scrollIntoView({ behavior: "smooth", block: "center" });
        }
    }, [tourOpen, tourSection]);

    const RenderActions = () => {
        //Make assessment update API call with status
        const handlePublish = async (e) => {
            e.preventDefault();
            /*
            const uinfo = await InvokeAPI(`${getAssessmentMgmtBase()}/v1/assessment/id`,
                { "ID": id },
                'POST',
                { "authorization": user["token"] },
                false)
            if (uinfo["unauthenticated"] == true || uinfo["unauthorized"] == true) {
                logout(user);
            }
            //console.log(uinfo.response)
            const aInfo = uinfo.response["AssessmentInfo"]
            */
            const status = await InvokeAPI(`${getAssessmentMgmtBase()}/v1/assessment/activate`,
                {
                    "ID": id
                },
                'POST',
                { "authorization": user["token"] },
                false)
            if (status["unauthenticated"] == true || status["unauthorized"] == true) {
                logout(user);
            }
            navigate("/app/practice")
        }
        return (
            <Box display="flex" justifyContent="center" alignItems="center">
                <AsyncButton type="submit" variant="contained" color="success" onClick={handlePublish} ref={publishRef}>
                    Publish
                </AsyncButton>
            </Box>
        )
    }

    const RenderMeta = () => {
        const [createData, setCreateData] = useState({
            name: '',
            subject: '',
            class: '',
            status: '',
            timed: false,
            durationHours: '',
            durationMinutes: '',
        });
        const [categories, setCategories] = useState({});
        const [subjects, setSubjects] = useState([]);
        
        const getCategories = async () => {
            const categories = await InvokeAPI(`${getAssessmentMgmtBase()}/v1/assessment/question/categories`,
                {},
                'POST',
                { "authorization": user["token"] },
                false)
            if (categories["unauthenticated"] == true || categories["unauthorized"] == true) {
                logout(user);
            }
            if (categories.internal) {
                return undefined
            }
            console.log(categories)
            const hash = categories.response.Categories.reduce((acc, item) => {
                acc[item.Sname] = acc[item.Sname] || {};
                acc[item.Sname][item.Cls] = acc[item.Sname][item.Cls] || [];
                acc[item.Sname][item.Cls].push(item.Cname);
                return acc;
            }, {});

            console.log(hash);
            return hash
        }
        
        const handleChange = (e) => {
            e.preventDefault();
            const { name, value } = e.target;
            if (name === 'subject') {
                // Reset class when subject changes
                setCreateData({ ...createData, subject: value, class: '' });
                // Auto-select first class for new subject
                if (categories[value]) {
                    const classes = Object.keys(categories[value]);
                    if (classes.length > 0) {
                        setTimeout(() => {
                            setCreateData(prev => ({ ...prev, class: classes[0] }));
                        }, 0);
                    }
                }
            } else {
                setCreateData({ ...createData, [name]: value });
            }
        };

        const handleUpdate = async (event) => {
            event.preventDefault();
            const hours = parseInt(createData.durationHours, 10) || 0;
            const minutes = parseInt(createData.durationMinutes, 10) || 0;
            const durationMinutes = createData.timed ? (hours * 60 + minutes) : 0;
            const status = await InvokeAPI(`${getAssessmentMgmtBase()}/v1/assessment/update`,
                {
                    "ID": id,
                    "Aname": createData.name,
                    "Asubject": createData.subject,
                    "Aclass": createData.class,
                    "Astatus": createData.status,
                    "CreatorID": user["id"],
                    "Duration": durationMinutes,
                },
                'POST',
                { "authorization": user["token"] },
                false)
            if (status["unauthenticated"] == true || status["unauthorized"] == true) {
                logout(user);
            }
            if (status.alreadyExists) {
                //alert("username already exists")
                setState({ open: true, severity: "warning", message: "Assessment name alreday exists" })
            } else if (status.iserror) {
                console.log(status)
                setState({ open: true, severity: "error", message: "Error updating Assessment" })
            } else {
                console.log(status)
                setState({ open: true, severity: "success", message: "Assessment updated successfully" })
            }
        };
        const getAssessmentMeta = async () => {
            const uinfo = await InvokeAPI(`${getAssessmentMgmtBase()}/v1/assessment/id`,
                { "ID": id },
                'POST',
                { "authorization": user["token"] },
                false)
            if (uinfo["unauthenticated"] == true || uinfo["unauthorized"] == true) {
                logout(user);
            }
            //console.log(uinfo.response)
            return uinfo.response["AssessmentInfo"]
        }

        useEffect(() => {
            //Some function
            getAssessmentMeta().then(data => {
                const duration = data.Duration || 0;
                const timed = duration > 0;
                const hours = timed ? Math.floor(duration / 60) : 0;
                const minutes = timed ? (duration % 60) : 0;
                setCreateData({ 
                    name: data.Aname, 
                    class: data.Aclass, 
                    subject: data.Asubject, 
                    status: data.Astatus,
                    timed: timed,
                    durationHours: timed ? hours.toString() : '',
                    durationMinutes: timed ? minutes.toString() : ''
                });
            })
            getCategories().then(data => {
                setCategories(data)
                if (data) {
                    // Extract subjects from categories
                    const subjectList = Object.keys(data);
                    setSubjects(subjectList);
                }
            })
        }, [])

        return (
            <Box sx={{ marginBottom: "20px" }}>
                <Grid2 container spacing={4}>
                    <Grid2 size={{ xs: 12, sm: 12, md: 8 }}>
                        <Stack>
                            <Box sx={{ paddingBottom: "10px" }}>
                                <Stack direction="row" spacing={1} alignItems="center" sx={{ paddingBottom: "5px" }}>

                                    <Assignment color="primary" />
                                    <TextField
                                        label={createData.name ? "" : "Name"}
                                        variant="outlined"
                                        name="name"

                                        value={createData.name}
                                        onChange={handleChange}
                                        required
                                        sx={{ m: 1, minWidth: '93%', verticalAlign: 'middle' }}
                                        InputLabelProps={{
                                            shrink: false,
                                        }}
                                    />
                                </Stack>
                                <br></br>
                            </Box>
                            <Box sx={{ paddingBottom: "10px" }}>
                                <Grid2 container spacing={2}>
                                    <Grid2 size={{ xs: 12, sm: 6 }}>
                                        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
                                            <ClassIcon sx={{ color: "orange" }} />
                                            <Typography variant="body2" sx={{ fontWeight: 500, color: 'text.secondary' }}>
                                                Subject
                                            </Typography>
                                        </Stack>
                                        <FormControl fullWidth>
                                            <Select
                                                value={createData.subject}
                                                onChange={handleChange}
                                                name="subject"
                                                displayEmpty
                                                sx={{
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        borderWidth: '1px',
                                                        borderStyle: 'solid',
                                                        borderColor: 'rgba(0, 0, 0, 0.23)',
                                                    },
                                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                                        borderColor: 'rgba(0, 0, 0, 0.87)',
                                                    },
                                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                        borderWidth: '2px',
                                                        borderColor: 'primary.main',
                                                    },
                                                }}
                                            >
                                                {subjects && subjects.map((row) => (
                                                    <MenuItem key={row} value={row}>{row}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid2>
                                    <Grid2 size={{ xs: 12, sm: 6 }}>
                                        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
                                            <SchoolIcon sx={{ color: "brown" }} />
                                            <Typography variant="body2" sx={{ fontWeight: 500, color: 'text.secondary' }}>
                                                Class
                                            </Typography>
                                        </Stack>
                                        <FormControl fullWidth>
                                            <Select
                                                value={createData.class || ''}
                                                onChange={handleChange}
                                                name="class"
                                                displayEmpty
                                                disabled={!createData.subject}
                                                sx={{
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        borderWidth: '1px',
                                                        borderStyle: 'solid',
                                                        borderColor: 'rgba(0, 0, 0, 0.23)',
                                                    },
                                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                                        borderColor: 'rgba(0, 0, 0, 0.87)',
                                                    },
                                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                        borderWidth: '2px',
                                                        borderColor: 'primary.main',
                                                    },
                                                }}
                                            >
                                                {createData.subject && categories[createData.subject] && Object.keys(categories[createData.subject]).map((cls) => (
                                                    <MenuItem key={cls} value={cls}>{cls}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid2>
                                </Grid2>
                                <br></br>
                            </Box>
                            <Box sx={{ paddingBottom: "10px" }}>
                                <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
                                    <Checkbox
                                        checked={createData.timed}
                                        onChange={(e) => {
                                            setCreateData({ 
                                                ...createData, 
                                                timed: e.target.checked, 
                                                durationHours: e.target.checked ? createData.durationHours : '', 
                                                durationMinutes: e.target.checked ? createData.durationMinutes : '' 
                                            });
                                        }}
                                        color="primary"
                                    />
                                    <Typography variant="body2" sx={{ fontWeight: 500, color: 'text.secondary' }}>
                                        Timed
                                    </Typography>
                                </Stack>
                                {createData.timed && (
                                    <Box>
                                        <Stack direction="row" spacing={1} alignItems="center">
                                            <TextField
                                                label="Hours"
                                                variant="outlined"
                                                name="durationHours"
                                                type="number"
                                                value={createData.durationHours}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    // Allow only digits, max 2 digits
                                                    const formatted = value.replace(/[^\d]/g, '').slice(0, 2);
                                                    setCreateData({ ...createData, durationHours: formatted });
                                                }}
                                                placeholder="00"
                                                inputProps={{ min: 0, max: 99 }}
                                                sx={{ m: 1, width: '100px', verticalAlign: 'middle' }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                            <Typography variant="h6" sx={{ color: 'text.secondary' }}>
                                                :
                                            </Typography>
                                            <TextField
                                                label="Minutes"
                                                variant="outlined"
                                                name="durationMinutes"
                                                type="number"
                                                value={createData.durationMinutes}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    // Allow only digits, max 2 digits, max 59
                                                    const formatted = value.replace(/[^\d]/g, '').slice(0, 2);
                                                    const numValue = parseInt(formatted, 10);
                                                    if (isNaN(numValue) || numValue <= 59) {
                                                        setCreateData({ ...createData, durationMinutes: formatted });
                                                    }
                                                }}
                                                placeholder="00"
                                                inputProps={{ min: 0, max: 59 }}
                                                sx={{ m: 1, width: '100px', verticalAlign: 'middle' }}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </Stack>
                                    </Box>
                                )}
                            </Box>
                            <Box display="flex" justifyContent="center" alignContent="center" alignItems="center">
                                <AsyncButton type="submit" variant="contained" color="primary" onClick={handleUpdate}>
                                    <UpdateIcon />&nbsp;Update
                                </AsyncButton>
                            </Box>
                        </Stack>
                    </Grid2>
                </Grid2>
                <Box display="none" justifyContent="center" alignItems="center">
                    <TextField
                        label="Name"
                        variant="outlined"
                        name="name"
                        required
                        value={createData.name}
                        onChange={handleChange}
                        sx={{ m: 1, width: '25ch', verticalAlign: 'middle' }}
                    />
                    <TextField
                        label="Subject"
                        variant="outlined"
                        name="subject"
                        required
                        value={createData.subject}
                        onChange={handleChange}
                        sx={{ m: 1, width: '25ch', verticalAlign: 'middle' }}
                    />
                    <TextField
                        label="Class"
                        variant="outlined"
                        name="class"
                        required
                        value={createData.class}
                        onChange={handleChange}
                        sx={{ m: 1, width: '25ch', verticalAlign: 'middle' }}
                    />


                </Box>
                <Box display="none" justifyContent="center" alignItems="center">
                    <AsyncButton type="submit" variant="contained" color="primary" onClick={handleUpdate} >
                        <UpdateIcon />&nbsp;Update
                    </AsyncButton>
                </Box>
            </Box>
        );
    }



    const RenderAssignTo = () => {
        const [assignment, setAssignment] = useState([]);

        const getAssessmentAssignedTo = async () => {
            const uinfo = await InvokeAPI(`${getAssessmentMgmtBase()}/v1/assessment/assignment/list`,
                { "Aid": id },
                'POST',
                { "authorization": user["token"] },
                false)
            if (uinfo["unauthenticated"] == true || uinfo["unauthorized"] == true) {
                logout(user);
            }
            //console.log(uinfo.response)
            return uinfo.response
        }

        /*
        const getEnrolledUsers = async () => {
            const uinfo = await InvokeAPI(`${getUserMgmtBase()}/v1/user/enrolled`,
                { "EnrollerID": user["id"] },
                'POST',
                { "authorization": user["token"] },
                false)
            if (uinfo["unauthenticated"] == true || uinfo["unauthorized"] == true) {
                logout(user);
            }
            //console.log(uinfo.response)
            return uinfo.response["EnrolledUsers"]
        }
        */

        useEffect(() => {
            //Some function
            getAssessmentAssignedTo().then(data => setAssignment(data))
            /*
            getEnrolledUsers().then(data => {
                const unassignedUsers = [];
                for (var i = 0; i < data.length; i++) {
                    if (users.assignedUsers.find((u) => u === data[i].ID) === undefined) {
                        unassignedUsers.push(data[i])
                    }
                }
                setUsers({ ...users, unassignedUsers: unassignedUsers, enrolledUsers: data })
            })*/
        }, [])

        const handleUserDelete = async (userID) => {
            const uinfo = await InvokeAPI(`${getAssessmentMgmtBase()}/v1/assessment/assignment/delete`,
                {
                    "Aid": id,
                    "UserID": [userID],
                },
                'POST',
                { "authorization": user["token"] },
                false)
            if (uinfo["unauthenticated"] == true || uinfo["unauthorized"] == true) {
                logout(user);
            }
            setState({ open: true, severity: "success", message: "Participant removed successfully" })
            //console.log(uinfo.response)
            //return uinfo.response
        }
        const handleGroupDelete = async (groupID) => {
            const uinfo = await InvokeAPI(`${getAssessmentMgmtBase()}/v1/assessment/assignment/delete`,
                {
                    "Aid": id,
                    "GroupID": [groupID],
                },
                'POST',
                { "authorization": user["token"] },
                false)
            if (uinfo["unauthenticated"] == true || uinfo["unauthorized"] == true) {
                logout(user);
            }
            setState({ open: true, severity: "success", message: "Participant removed successfully" })
            //console.log(uinfo.response)
            //return uinfo.response
        }

        return (
            <Box style={{ padding: "10px 10px 10px 10px" }}>
                <Box display="flex" justifyContent="center" alignItems="center">
                    <Button sx={{ textTransform: "initial" }} type="submit" variant="contained" color="primary" onClick={() => { navigate('/app/practice/edit/participants/' + id, { replace: false }) }} >
                        <AddCircle /> &nbsp; Add Participant(s)
                    </Button>
                </Box>
                {assignment && assignment.UsersInfo && assignment.UsersInfo.length !== 0 ?
                    <Box style={{ margin: "10px 10px 10px 10px", padding: "10px" }}>
                        <Typography variant="h6" sx={{ color: "primary.main", mb: 1 }}>Added Participant(s):</Typography>
                        <TableContainer component={Paper}>
                            <Table
                                aria-label="customized table"
                                sx={{ tableLayout: 'fixed', width: '100%' }}
                            >
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>UserName</StyledTableCell>
                                        <StyledTableCell>First Name</StyledTableCell>
                                        <StyledTableCell>Last Name</StyledTableCell>
                                        <StyledTableCell align="right" sx={{ width: 72, minWidth: 72, maxWidth: 72, px: 1, whiteSpace: 'nowrap' }}>Actions</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {assignment && assignment.UsersInfo && assignment.UsersInfo.map((row) => (
                                        <StyledTableRow key={row.Username}>
                                            <StyledTableCell component="th" scope="row">
                                                {row.Username}
                                            </StyledTableCell>
                                            <StyledTableCell>{row.Fname}</StyledTableCell>
                                            <StyledTableCell>{row.Lname}</StyledTableCell>
                                            <StyledTableCell align="right" sx={{ width: 72, minWidth: 72, maxWidth: 72, px: 0.5, verticalAlign: 'middle' }}>
                                                <Tooltip title="Remove Participant">
                                                    <IconButton size="small">
                                                        <DeleteIcon type="submit" variant="outlined" color="error"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                setDialog({
                                                                    open: true,
                                                                    user: true,
                                                                    group: false,
                                                                    id: row.ID,
                                                                    button: "Remove Participant",
                                                                    content: "Are you sure you want to remove the participant " + row.Username + " from this assignment?"
                                                                })
                                                            }} />
                                                    </IconButton>
                                                </Tooltip>
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                    :
                    <Box style={{ margin: "10px 10px 10px 10px", padding: "10px" }}>
                        <Typography variant="h6" sx={{ color: "primary.main", mb: 1 }}>No Participant have been added so far</Typography>
                    </Box>
                }
                {/*
                assignment && assignment.GroupsInfo && assignment.GroupsInfo.length !== 0 ?
                    <Box style={{ margin: "10px 10px 10px 10px", padding: "10px" }}>
                        <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, textAlign: 'center' }}>Added Groups:</Typography>
                        <Box sx={{ borderRadius: 2, overflow: 'hidden' }}>
                            <TableContainer component={Paper}>
                                <Table aria-label="customized table">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell
                                                sx={{
                                                    borderTopLeftRadius: '12px',
                                                    '&:first-of-type': {
                                                        borderTopLeftRadius: '12px'
                                                    }
                                                }}
                                            >
                                                Name
                                            </StyledTableCell>
                                            <StyledTableCell
                                                sx={{
                                                    borderTopRightRadius: '12px',
                                                    '&:last-of-type': {
                                                        borderTopRightRadius: '12px'
                                                    }
                                                }}
                                            >
                                                Description
                                            </StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {assignment && assignment.GroupsInfo && assignment.GroupsInfo.length > 0 ? (
                                            assignment.GroupsInfo.map((row, idx) => {
                                                const isLast = idx === assignment.GroupsInfo.length - 1;
                                                return (
                                                    <StyledTableRow key={row.Gname}>
                                                        <StyledTableCell 
                                                            component="th" 
                                                            scope="row"
                                                            sx={isLast ? { 
                                                                borderBottomLeftRadius: '12px',
                                                                paddingBottom: '16px',
                                                                paddingLeft: '16px'
                                                            } : { paddingLeft: '16px' }}
                                                        >
                                                            <Link component="button" underline="none" onClick={() => { navigate("/app/group/" + row.ID) }}>{row.Gname}</Link>
                                                            <Tooltip title="Delete">
                                                                <IconButton>
                                                                    <DeleteIcon type="submit" variant="outlined" color="error"
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            setDialog({
                                                                                open: true,
                                                                                user: false,
                                                                                group: true,
                                                                                id: row.ID,
                                                                                button: "Delete Group",
                                                                                content: "Are you sure you want to remove the participant " + row.Gname + " from this assessment?"
                                                                            })
                                                                        }} />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </StyledTableCell>
                                                        <StyledTableCell
                                                            sx={isLast ? { 
                                                                borderBottomRightRadius: '12px',
                                                                paddingBottom: '16px',
                                                                paddingRight: '16px'
                                                            } : { paddingRight: '16px' }}
                                                        >
                                                            {row.Gdescription}
                                                        </StyledTableCell>
                                                    </StyledTableRow>
                                                );
                                            })
                                        ) : (
                                            <StyledTableRow>
                                                <StyledTableCell colSpan={2} sx={{ textAlign: 'center', py: 3 }}>
                                                    No groups added yet
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </Box>
                    :
                    <Box style={{ margin: "10px 10px 10px 10px", padding: "10px" }}>
                        <Typography variant="h6" sx={{ color: "primary.main", mb: 1 }}>No Groups have been added so far</Typography>
                    </Box>
                */}
            </Box>
        );
    }

    const RenderManuallyAddQuestion = () => {
        return (
            <Box style={{ padding: "10px 10px 10px 10px" }}>
                <Accordion sx={{ border: 1, color: 'primary.main' }}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="manually-add-content"
                        id="manually-add"
                    >
                        <Typography component="span">Manually Add</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ color: 'black' }}>
                        <TextField
                            label="Question"
                            variant="outlined"
                            name="question"
                            required
                            sx={{ m: 1, width: '25ch', verticalAlign: 'middle' }}
                            InputLabelProps={{
                                shrink: false,
                            }}
                        />
                        <TextField
                            label="Answer"
                            variant="outlined"
                            name="answer"
                            required
                            sx={{ m: 1, width: '25ch', verticalAlign: 'middle' }}
                            InputLabelProps={{
                                shrink: false,
                            }}
                        />
                        <TextField
                            label="Solution"
                            variant="outlined"
                            name="solution"
                            required
                            sx={{ m: 1, width: '25ch', verticalAlign: 'middle' }}
                            InputLabelProps={{
                                shrink: false,
                            }}
                        />
                        <Button type="submit" variant="contained" color="primary" >
                            Add
                        </Button>
                    </AccordionDetails>
                </Accordion>
            </Box>
        )
    }

    const RenderAskAIForQuestion = () => {
        return (
            <Box style={{ padding: "10px 10px 10px 10px" }}>
                <Accordion sx={{ border: 1, color: 'primary.main' }}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="render-ask-ai-content"
                        id="render-ask-ai"
                    >
                        <Typography component="span">Ask AI</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ color: 'black' }}>
                        Search with AI and display things as selectable tables
                    </AccordionDetails>
                </Accordion>
            </Box>
        )
    }

    const RenderAddedQuestions = () => {

        const [questions, setQuestions] = useState([]);

        const getAssessmentQuestions = async () => {
            const uinfo = await InvokeAPI(`${getAssessmentMgmtBase()}/v1/assessment/question/list`,
                {
                    "Aid": id,
                    "FillMeta": true,
                    "FillOptions": true,
                    "FillAnswer": true,
                    "FillSolution": true,
                },
                'POST',
                { "authorization": user["token"] },
                false)
            if (uinfo["unauthenticated"] == true || uinfo["unauthorized"] == true) {
                logout(user);
            }
            if (uinfo.internal) {
                return undefined
            }
            //console.log(uinfo)
            return uinfo.response["QuestionsInfo"]
        }

        useEffect(() => {
            getAssessmentQuestions().then(data => setQuestions(data))
        }, [])

        var qCount = 0

        const renderQuestions = (questions) => {
            return (
                <Box>
                    {questions.map((qlist) => (
                        <Box sx={{ paddingTop: "10px", width: '100%' }}>
                            <Card
                                elevation={6}
                                sx={{
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    position: 'relative',
                                    borderRadius: 3,
                                    paddingRight: "5px",
                                    paddingLeft: "5px",
                                    border: '1px solid',
                                    borderColor: 'divider',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.08), 0 0 0 1px rgba(0,0,0,0.04)',
                                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                    '&:hover': {
                                        boxShadow: '0 8px 24px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.06)',
                                        transform: 'translateY(-4px)',
                                    },
                                }}>
                                <CardContent>
                                    <Box sx={{ position: "absolute", top: 10, right: 10 }}>
                                        <Tooltip title="Delete">
                                            <IconButton>
                                                <DeleteIcon type="submit" variant="outlined" color="error"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        setDialog({
                                                            open: true,
                                                            user: false,
                                                            group: false,
                                                            question: true,
                                                            id: qlist.QID,
                                                            button: "Remove Question",
                                                            content: "Are you sure you want to remove the question `" + qlist.Question + "` from this assignment?"
                                                        })
                                                    }} />
                                            </IconButton>
                                        </Tooltip>
                                    </Box>
                                    <Box sx={{ mb: 2 }}>
                                        <Typography variant="body2" color="text.secondary">
                                            Level: {qlist.Qlevel}
                                        </Typography>
                                        <Typography display="none" variant="body2" color="text.secondary">
                                            Type: {qlist.Options.length !== 0 ? "MCQ" : "Text Response"}
                                        </Typography>
                                    </Box>

                                    <b>{++qCount}. Question:</b> {qlist.Question} &nbsp;
                                    {qlist.Options.length !== 0 && <Box display="flex" style={{ paddingLeft: "50px" }}>
                                        {qlist.Options.length !== 0 && <b>Options:</b>}
                                        <Stack>

                                            {qlist.Options.map((lrow, index) => (
                                                <>&nbsp;{index + 1}.&nbsp;{lrow}<br></br></>
                                            ))}
                                        </Stack>
                                    </Box>}
                                    <Box sx={{ mb: 2, paddingTop: "10px" }}>
                                        <Typography variant="body2" color="text.secondary">
                                            Answer: {qlist.Answer}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            Solution: {qlist.Solution}
                                        </Typography>
                                    </Box>
                                </CardContent>
                            </Card>
                        </Box>
                    ))
                    }
                </Box>
            )
        }


        const renderSearchedQuestion = (qas) => {
            return (
                <>
                    <Box display="flex" sx={{ width: '100%' }}>
                        {
                            qas.MetaText !== "" ?
                                <Box sx={{ paddingTop: "10px", width: '100%' }}>
                                    <Card
                                        elevation={6}
                                        sx={{
                                            borderRadius: 3,
                                            paddingRight: "5px",
                                            paddingLeft: "5px",
                                            border: '1px solid',
                                            borderColor: 'divider',
                                            boxShadow: '0 2px 8px rgba(0,0,0,0.08), 0 0 0 1px rgba(0,0,0,0.04)',
                                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                            '&:hover': {
                                                boxShadow: '0 8px 24px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.06)',
                                                transform: 'translateY(-4px)',
                                            },
                                        }}>
                                        <CardContent>
                                            <h3>Passage:</h3>{qas.MetaText}
                                            {renderQuestions(qas.Questions)}
                                        </CardContent>
                                    </Card>
                                </Box>
                                :
                                <Box sx={{ paddingTop: "10px", width: '100%' }}>
                                    {renderQuestions(qas.Questions)}
                                </Box>
                        }
                    </Box>

                    <Box sx={{ display: "none" }}>
                        {qas.MetaText !== "" && <StyledTableRow>
                            <StyledTableCell component="th" scope="row" colSpan={1}>
                                <h3>Passage:</h3>{qas.MetaText}
                            </StyledTableCell>
                        </StyledTableRow>}
                        {qas.Questions.map((qlist) => (
                            <StyledTableRow key={qlist.QID}>
                                <StyledTableCell component="th" scope="row">
                                    {qlist.Question}
                                    <Tooltip title="Delete">
                                        <IconButton>
                                            <DeleteIcon type="submit" variant="outlined" color="error"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setDialog({
                                                        open: true,
                                                        user: false,
                                                        group: false,
                                                        question: true,
                                                        id: qlist.QID,
                                                        button: "Remove Question",
                                                        content: "Are you sure you want to remove the question `" + qlist.Question + "` from this assignment?"
                                                    })
                                                }} />
                                        </IconButton>
                                    </Tooltip>
                                    {qlist.Options.length !== 0 && <Box display="flex" style={{ paddingLeft: "20px" }}>
                                        <Stack>
                                            {qlist.Options.length !== 0 && <h3>Options:</h3>}
                                            {qlist.Options.map((lrow, index) => (
                                                <>&nbsp;{index + 1}.&nbsp;{lrow}<br></br></>
                                            ))}
                                        </Stack>
                                    </Box>}
                                </StyledTableCell>
                            </StyledTableRow>
                        ))
                        }
                    </Box>
                </>
            )
        }

        return (
            <Box style={{ margin: "10px 10px 10px 10px" }}>

                <Box display="flex" justifyContent="center" alignItems="center">
                    <Button sx={{ textTransform: "initial" }} type="submit" variant="contained" color="primary" onClick={() => { navigate('/app/practice/edit/questions/' + id, { replace: false }) }} >
                        <AddCircle /> &nbsp; Add Question(s)
                    </Button>
                </Box>
                {questions && questions.length !== 0 ?
                    <Typography variant="h6" sx={{ color: "primary.main", mb: 1 }}>Added Questions:</Typography>
                    :
                    <Typography variant="h6" sx={{ color: "primary.main", mb: 1 }}>No Questions Added so far</Typography>
                }

                {questions && questions.map((row) => (
                    <Box sx={{ paddingBottom: "20px", width: '100%' }}>
                        {renderSearchedQuestion(row)}
                    </Box>
                ))}
                <TableContainer sx={{ display: "none" }} component={Paper}>
                    <Table sx={{ minWidth: 700 }} aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell>Question</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {questions && questions.map((row) => (
                                <>{renderSearchedQuestion(row)}</>
                                /*
                                <StyledTableRow key={row.Qtext}>
                                    <StyledTableCell component="th" scope="row">
                                        {row.Qtext} &nbsp;
                                        {
                                            <Tooltip title="Delete">
                                                <IconButton>
                                                    <DeleteIcon type="submit" variant="outlined" color="error"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            setDialog({
                                                                open: true,
                                                                user: false,
                                                                group: false,
                                                                question: true,
                                                                id: row.QID,
                                                                button: "Remove Question",
                                                                content: "Are you sure you want to remove the question `" + row.Qtext + "` from this assessment?"
                                                            })
                                                        }} />
                                                </IconButton>
                                            </Tooltip>
                                        }
                                    </StyledTableCell>
                                </StyledTableRow>
                                */
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        )
    }

    /*
       <RenderManuallyAddQuestion />
                    <RenderAskAIForQuestion />
    */
    return (
        <Box sx={{ overflow: 'auto', scrollbarWidth: 'thin', paddingBottom: '80px' }}>
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={state.open}
                onClose={handleClose}
                key={state.message}
                autoHideDuration={1000}
            >
                <Alert variant="filled" severity={state.severity}>
                    {state.message}
                </Alert>
            </Snackbar>
            <Dialog
                open={dialog.open}
                onClose={handleDialogClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {dialog.content}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <AsyncButton onClick={handleDialogContinue} loading={dialogSubmitting}>
                        {dialog.button}
                    </AsyncButton>
                    <Button onClick={handleDialogClose} autoFocus disabled={dialogSubmitting}>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
            <Button
                variant="text"
                startIcon={<ArrowBackIcon />}
                onClick={() => navigate(-1)}
                sx={{ color: "blue" }}
            >
                Go Back
            </Button>

            {isStudent() ? (<>You are not allowed to edit this.</>) : (
                <Stack>
                    <Box sx={{ display: "flex", justifyContent: "right", alignItems: "center", mb: 1 }}>
                        <Button variant="outlined" onClick={startTour}>
                            Take a tour
                        </Button>
                    </Box>
                    <Grid2 container spacing={2}>
                        <Grid2 size={{ xs: 12, sm: 12, md: 12 }}>
                            <Card 
                                ref={detailsRef}
                                elevation={6}
                                sx={{
                                    borderRadius: 4,
                                    border: '1px solid',
                                    borderColor: tourOpen && tourSections[tourSection]?.targetRef === detailsRef ? 'primary.main' : 'divider',
                                    boxShadow: tourOpen && tourSections[tourSection]?.targetRef === detailsRef
                                        ? '0 0 0 3px rgba(25,118,210,0.25), 0 8px 24px rgba(0,0,0,0.12)'
                                        : '0 4px 16px rgba(0,0,0,0.1), 0 0 0 1px rgba(0,0,0,0.05)',
                                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                    '&:hover': {
                                        boxShadow: '0 8px 24px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.06)',
                                        transform: 'translateY(-2px)',
                                    },
                                }}
                            >
                                <CardHeader 
                                    sx={{ textAlign: 'center', pb: 1 }}
                                    title={
                                        <Typography 
                                            sx={{ 
                                                fontWeight: 600,
                                                fontSize: '1.125rem',
                                                color: 'text.primary',
                                                letterSpacing: '-0.01em',
                                                textAlign: 'center',
                                                width: '100%'
                                            }} 
                                            variant="h6"
                                        >
                                            Edit Details
                                        </Typography>
                                    } 
                                />
                                <CardContent>
                                    <RenderMeta />
                                </CardContent>
                            </Card>
                        </Grid2>
                        <Grid2 size={{ xs: 12, sm: 12, md: 12 }}>
                            <Card 
                                ref={participantsRef}
                                elevation={6}
                                sx={{
                                    borderRadius: 4,
                                    border: '1px solid',
                                    borderColor: tourOpen && tourSections[tourSection]?.targetRef === participantsRef ? 'primary.main' : 'divider',
                                    boxShadow: tourOpen && tourSections[tourSection]?.targetRef === participantsRef
                                        ? '0 0 0 3px rgba(25,118,210,0.25), 0 8px 24px rgba(0,0,0,0.12)'
                                        : '0 4px 16px rgba(0,0,0,0.1), 0 0 0 1px rgba(0,0,0,0.05)',
                                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                    '&:hover': {
                                        boxShadow: '0 8px 24px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.06)',
                                        transform: 'translateY(-2px)',
                                    },
                                }}
                            >
                                <CardHeader 
                                    sx={{ textAlign: 'center', pb: 1 }}
                                    title={
                                        <Typography 
                                            sx={{ 
                                                fontWeight: 600,
                                                fontSize: '1.125rem',
                                                color: 'text.primary',
                                                letterSpacing: '-0.01em',
                                                textAlign: 'center',
                                                width: '100%'
                                            }} 
                                            variant="h6"
                                        >
                                            Edit Participants
                                        </Typography>
                                    } 
                                />
                                <CardContent>
                                    <RenderAssignTo />
                                </CardContent>
                            </Card>
                        </Grid2>
                        <Grid2 size={{ xs: 12, sm: 12, md: 12 }}>
                            <Card 
                                ref={questionsRef}
                                elevation={6}
                                sx={{
                                    borderRadius: 4,
                                    border: '1px solid',
                                    borderColor: tourOpen && tourSections[tourSection]?.targetRef === questionsRef ? 'primary.main' : 'divider',
                                    boxShadow: tourOpen && tourSections[tourSection]?.targetRef === questionsRef
                                        ? '0 0 0 3px rgba(25,118,210,0.25), 0 8px 24px rgba(0,0,0,0.12)'
                                        : '0 4px 16px rgba(0,0,0,0.1), 0 0 0 1px rgba(0,0,0,0.05)',
                                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                    '&:hover': {
                                        boxShadow: '0 8px 24px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.06)',
                                        transform: 'translateY(-2px)',
                                    },
                                }}
                            >
                                <CardHeader 
                                    sx={{ textAlign: 'center', pb: 1 }}
                                    title={
                                        <Typography 
                                            sx={{ 
                                                fontWeight: 600,
                                                fontSize: '1.125rem',
                                                color: 'text.primary',
                                                letterSpacing: '-0.01em',
                                                textAlign: 'center',
                                                width: '100%'
                                            }} 
                                            variant="h6"
                                        >
                                            Edit Questions
                                        </Typography>
                                    } 
                                />
                                <CardContent>
                                    <RenderAddedQuestions />
                                </CardContent>
                            </Card>
                        </Grid2>
                    </Grid2>
                    <br></br>
                    <RenderActions />
                </Stack>
            )
            }

            {tourOpen && (
                <Paper
                    elevation={12}
                    sx={{
                        position: "fixed",
                        right: 24,
                        bottom: 24,
                        width: { xs: "calc(100% - 32px)", sm: 390 },
                        p: 2,
                        borderRadius: 2,
                        zIndex: 2000,
                        border: "1px solid",
                        borderColor: "divider",
                    }}
                >
                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                        Section {tourSection + 1} of {tourSections.length}: {tourSections[tourSection].title}
                    </Typography>
                    <Typography variant="body2" sx={{ mt: 1, color: "text.secondary" }}>
                        {tourSections[tourSection].description}
                    </Typography>
                    <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
                        <Button onClick={closeTour} color="inherit">
                            Skip
                        </Button>
                        <Box sx={{ display: "flex", gap: 1 }}>
                            <Button
                                variant="outlined"
                                onClick={() => goToTourSection(tourSection - 1)}
                                disabled={tourSection === 0}
                            >
                                Back
                            </Button>
                            <Button
                                variant="contained"
                                onClick={() => goToTourSection(tourSection + 1)}
                            >
                                {tourSection === tourSections.length - 1 ? "Done" : "Next"}
                            </Button>
                        </Box>
                    </Box>
                </Paper>
            )}
        </Box>
    );
};


export default AssessmentEdit;